import { useEffect, useState } from "react";
import { adminApi } from "../lib/adminAuth";
import { formatDate } from "../lib/api";
import ConfirmModal from "./ConfirmModal";

const FILTERS = [
  { id: "todos", label: "Todos" },
  { id: "pendiente", label: "Pendientes" },
  { id: "aprobado", label: "Aprobados" },
  { id: "eliminado", label: "Eliminados" },
];

export default function PanelComentarios({ onChange }) {
  const [filter, setFilter] = useState("pendiente");
  const [data, setData] = useState({ items: [], counts: {}, total: 0 });
  const [confirm, setConfirm] = useState(null);

  const load = () => {
    adminApi
      .get("/admin/comentarios", { params: { estado: filter, per_page: 50 } })
      .then((r) => setData(r.data));
  };

  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [filter]);

  const moderate = async (id, estado) => {
    await adminApi.patch(`/admin/comentarios/${id}`, { estado });
    load();
    if (onChange) onChange();
  };

  const askDelete = (c) =>
    setConfirm({
      title: "¿Eliminar comentario?",
      message: `Vas a borrar el comentario de ${c.nombre}. Esta acción es definitiva.`,
      onConfirm: async () => {
        await adminApi.delete(`/admin/comentarios/${c.id}`);
        setConfirm(null);
        load();
        if (onChange) onChange();
      },
    });

  return (
    <div data-testid="panel-comentarios">
      <div className="panel-eyebrow">Moderación</div>
      <h1>
        Comentarios
        {data.counts.pendientes > 0 && (
          <span style={{ marginLeft: 12, color: "var(--accent)", fontSize: "1rem" }}>
            {data.counts.pendientes} pendiente{data.counts.pendientes === 1 ? "" : "s"}
          </span>
        )}
      </h1>

      <div className="panel-controls" style={{ marginTop: 24 }}>
        {FILTERS.map((f) => (
          <button
            key={f.id}
            className={`tag-btn ${filter === f.id ? "active" : ""}`}
            onClick={() => setFilter(f.id)}
            data-testid={`comentarios-filter-${f.id}`}
          >
            {f.label}
            {f.id !== "todos" && (
              <span style={{ marginLeft: 8, opacity: 0.7 }}>
                ({data.counts[f.id === "pendiente" ? "pendientes" : f.id === "aprobado" ? "aprobados" : "eliminados"] || 0})
              </span>
            )}
          </button>
        ))}
      </div>

      <div className="panel-card">
        {data.items.length === 0 ? (
          <p style={{ color: "var(--ink-3)", padding: 20, textAlign: "center" }}>
            No hay comentarios en este estado.
          </p>
        ) : (
          <table className="panel-table" data-testid="comentarios-list">
            <thead>
              <tr>
                <th>Post</th>
                <th>Nombre</th>
                <th>Fecha</th>
                <th>Texto</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((c) => (
                <tr key={c.id} data-testid={`comentario-row-${c.id}`}>
                  <td style={{ fontSize: "0.84rem", color: "var(--ink-3)", maxWidth: 140 }}>
                    {c.post_slug}
                  </td>
                  <td style={{ fontWeight: 500 }}>{c.nombre}</td>
                  <td style={{ fontSize: "0.84rem" }}>{formatDate(c.fecha)}</td>
                  <td style={{ color: "var(--ink-2)", maxWidth: 320 }}>
                    {c.texto.length > 80 ? c.texto.slice(0, 80) + "…" : c.texto}
                  </td>
                  <td>
                    <span className={`estado-pill ${c.estado}`}>{c.estado}</span>
                  </td>
                  <td>
                    <div className="panel-actions">
                      {c.estado !== "aprobado" && (
                        <button className="btn-tiny success" onClick={() => moderate(c.id, "aprobado")} data-testid={`comentario-aprobar-${c.id}`}>
                          Aprobar
                        </button>
                      )}
                      <button className="btn-tiny danger" onClick={() => askDelete(c)} data-testid={`comentario-eliminar-${c.id}`}>
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {confirm && <ConfirmModal {...confirm} onCancel={() => setConfirm(null)} />}
    </div>
  );
}
